export const LAYERIZE_MIN_PIXEL_AREA = 512 * 512;

export const isLayerizeImageTooSmall = ({ width, height } = {}) => {
  const nextWidth = Number(width) || 0;
  const nextHeight = Number(height) || 0;
  if (nextWidth <= 0 || nextHeight <= 0) return false;
  return nextWidth * nextHeight < LAYERIZE_MIN_PIXEL_AREA;
};
